import React from "react";
import { motion } from "framer-motion";
import aboutimg from "../assets/images/Image (1).png";

const AboutMe = () => {
  return (
    <motion.div
      className="about__me"
      id="about-me"
      whileInView={{ y: [100, 50, 0], opacity: [0, 0, 1] }}
      transition={{ duration: 0.5 }}
    >
      <div className="app__projects-heading">
        <div className="projects__heading-text">
          <h2 className="head-text">
            <span className="p-ctext">#</span>About-Me
          </h2>
          <div className="horizontal-line"></div>
        </div>
      </div>

      <div className="about__me-container">
        <div className="about__me-text">
          <p>
            Hello, i’m Uchenna Ezedinma!
            <br />
            <br />
            I’m a fullstack software engineer based in Port-Harcourt, Nigeria.
            With a passion for technology and continuous learning, I have
            developed a broad skill set that spans both frontend and backend
            development.
            <br />
            <br />
            My journey in software engineering has been driven by curiosity and
            a desire to solve real-world problems through innovative digital
            solutions. Whether it's building dynamic web applications or
            creating efficient backend systems, I am committed to delivering
            high-quality, user-centric products. As a versatile developer, I
            thrive in dynamic environments and am always eager to embrace new
            challenges and technologies.
            <br />
            <br />
          </p>
        </div>

        <div className="about__me-img">
          <img src={aboutimg} alt="image-pic" />
        </div>
      </div>
    </motion.div>
  );
};

export default AboutMe;
